import '../../../styles/Home/sponsors.scss';
import { motion } from 'framer-motion';

const Sponsors = () => {
  return (
    <div className="sponsors__wrap" id="sponsors">
      <h1 className="sponsors__heading">Sponsors</h1>
      <motion.div className="sponsors" initial={{ x: '110%' }} animate={{ x: '-530rem' }} transition={{ repeat: Infinity, duration: 30, ease: "linear" }}>
        <img src="https://i.imgur.com/U6FxoV6.png" alt="microsoft" />
        <img src='https://github.githubassets.com/images/modules/logos_page/GitHub-Logo.png' alt="github" />
        <img src="https://images.givelively.org/nonprofits/bf8c9575-7cfe-4b4e-a075-aae637fba6df/logos/youth-leadership-incubator-inc_processed_cf7f35e74d3a5aa43416065b9263e26666e040afcf8c3ad7f4e1536bc4e86b00_logo.png" alt="hack+" />

        <img src="https://i.imgur.com/U6FxoV6.png" alt="microsoft" />
        <img src='https://github.githubassets.com/images/modules/logos_page/GitHub-Logo.png' alt="github" />
        <img src="https://images.givelively.org/nonprofits/bf8c9575-7cfe-4b4e-a075-aae637fba6df/logos/youth-leadership-incubator-inc_processed_cf7f35e74d3a5aa43416065b9263e26666e040afcf8c3ad7f4e1536bc4e86b00_logo.png" alt="hack+" />

        <img src="https://i.imgur.com/U6FxoV6.png" alt="microsoft" />
        <img src='https://github.githubassets.com/images/modules/logos_page/GitHub-Logo.png' alt="github" />
        <img src="https://images.givelively.org/nonprofits/bf8c9575-7cfe-4b4e-a075-aae637fba6df/logos/youth-leadership-incubator-inc_processed_cf7f35e74d3a5aa43416065b9263e26666e040afcf8c3ad7f4e1536bc4e86b00_logo.png" alt="hack+" />

        <img src="https://i.imgur.com/U6FxoV6.png" alt="microsoft" />
        <img src='https://github.githubassets.com/images/modules/logos_page/GitHub-Logo.png' alt="github" />
        <img src="https://images.givelively.org/nonprofits/bf8c9575-7cfe-4b4e-a075-aae637fba6df/logos/youth-leadership-incubator-inc_processed_cf7f35e74d3a5aa43416065b9263e26666e040afcf8c3ad7f4e1536bc4e86b00_logo.png" alt="hack+" />

        <img src="https://i.imgur.com/U6FxoV6.png" alt="microsoft" />
        <img src='https://github.githubassets.com/images/modules/logos_page/GitHub-Logo.png' alt="github" />
        <img src="https://images.givelively.org/nonprofits/bf8c9575-7cfe-4b4e-a075-aae637fba6df/logos/youth-leadership-incubator-inc_processed_cf7f35e74d3a5aa43416065b9263e26666e040afcf8c3ad7f4e1536bc4e86b00_logo.png" alt="hack+" />
      </motion.div>
    </div>

  )
}

export default Sponsors;